/* Opens image links in a dialog instead of a new tab, with focus handling. */
(function () {
  var IMAGE = /\.(jpe?g|png|webp|gif|avif)(\?|#|$)/i;
  var lb, dialog, img, title, opener;

  function nodes() {
    lb = document.querySelector('[data-zen-lb]');
    if (!lb) return false;
    dialog = lb.querySelector('[role="dialog"]');
    img = lb.querySelector('[data-zen-lb-img]');
    title = lb.querySelector('[data-zen-lb-title]');
    return true;
  }

  function focusable() {
    return Array.prototype.filter.call(
      dialog.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'),
      // offsetParent is null for fixed elements, so measure boxes instead:
      // the close button is fixed and must stay in the tab order.
      function (el) { return el.getClientRects().length > 0; }
    );
  }

  function open(href, label, trigger) {
    if (!nodes()) return;
    opener = trigger || null;
    img.src = href;
    img.alt = label || 'Product label';
    title.textContent = label || 'Product label';
    lb.hidden = false;
    document.body.style.overflow = 'hidden';
    dialog.focus();
  }

  function close() {
    if (!lb || lb.hidden) return;
    lb.hidden = true;
    img.src = '';
    document.body.style.overflow = '';
    if (opener && typeof opener.focus === 'function') opener.focus();
    opener = null;
  }

  document.addEventListener('click', function (e) {
    var closer = e.target.closest && e.target.closest('[data-zen-lb-close]');
    if (closer) {
      // The overlay carries the close hook, so ignore clicks that land on the
      // panel itself; only the surround and the button dismiss it.
      var inPanel = e.target.closest('[role="dialog"]');
      var onButton = e.target.closest('.zen-lb__close');
      if (inPanel && !onButton) return;
      e.preventDefault();
      close();
      return;
    }

    var link = e.target.closest && e.target.closest('a[data-zen-lightbox]');
    if (!link) return;
    var href = link.getAttribute('href') || '';
    // Anything that is not an image keeps its normal behaviour.
    if (!IMAGE.test(href)) return;
    e.preventDefault();
    open(href, link.getAttribute('data-zen-lightbox') || (link.textContent || '').trim(), link);
  });

  document.addEventListener('keydown', function (e) {
    if (!lb || lb.hidden) return;
    if (e.key === 'Escape') { e.preventDefault(); close(); return; }
    if (e.key !== 'Tab') return;
    // Keep tabbing inside the dialog while it is open.
    var items = focusable();
    if (!items.length) { e.preventDefault(); dialog.focus(); return; }
    var first = items[0];
    var last = items[items.length - 1];
    var active = document.activeElement;
    if (e.shiftKey && (active === first || active === dialog)) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && active === last) { e.preventDefault(); first.focus(); }
  });
})();
